import { WindowLocationService } from '~src/commonInfra/services/WindowLocationService';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import WebHttpClient from '~src/httpClient/WebHttpClient';
import { WebHttpClientWithErrorToastInstance } from '~src/httpClient/WebHttpClientWithErrorToast';

import { ApproveClusterNodeRequest, IApproveClusterNodeParams } from '../requests/ApproveClusterNodeRequest';
import { CreateBaasEdgePoolRequest, ICreateBaasEdgePoolParams } from '../requests/CreateBaasEdgePoolRequest';
import { DeleteBaasEdgePoolRequest, IDeleteBaasEdgePoolParams } from '../requests/DeleteBaasEdgePoolRequest';
import { DeletePoolNodeRequest, IDeletePoolNodeParams } from '../requests/DeletePoolNodeRequest';
import { IDownloadScriptParams } from '../requests/DownloadScript';
import { GetBaasClusterDetailsRequest, IGetBaasClusterDetailsParams } from '../requests/GetBaasClusterDetailsRequest';
import { GetBaasEdgePoolsRequest, IGetBaasEdgePoolsParams } from '../requests/GetBaasEdgePoolsRequest';
import { GetDockerRegistryRequest, IGetDockerRegistryParams } from '../requests/GetDockerRegistryRequest';
import { IRefreshBaseImageParams, RefreshBaseImageRequest } from '../requests/RefreshBaseImageRequest';
import { IRejectPoolNodeParams, RejectPoolNodeRequest } from '../requests/RejectPoolNodeRequest';
import { IUpdateBaasEdgePoolParams, UpdateBaasEdgePoolRequest } from '../requests/UpdateBaasEdgePoolRequest';
import { IUpdateBaasPoolServiceTokensParams, UpdateBaasPoolServiceTokensRequest } from '../requests/UpdateBaasPoolServiceTokensRequest';

export namespace BaasEdgePool {

  export function createBaasPool(params: ICreateBaasEdgePoolParams): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new CreateBaasEdgePoolRequest({ ...params }));
  }

  export function getBaasPools(params: IGetBaasEdgePoolsParams): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new GetBaasEdgePoolsRequest({ ...params }));
  }

  export function deleteBaasPools(params: IDeleteBaasEdgePoolParams): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new DeleteBaasEdgePoolRequest({ ...params }));
  }

  export function updateBaasPool(params: IUpdateBaasEdgePoolParams): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new UpdateBaasEdgePoolRequest({ ...params }));
  }

  export function approveClusterNode(params: IApproveClusterNodeParams): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new ApproveClusterNodeRequest({ ...params }));
  }

  export function updateBaasPoolServiceTokens(params: IUpdateBaasPoolServiceTokensParams): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new UpdateBaasPoolServiceTokensRequest({ ...params }));
  }

  export function refreshBaseImage(params: IRefreshBaseImageParams): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new RefreshBaseImageRequest({ ...params }));
  }

  export function getBaasClusterDetails(params: IGetBaasClusterDetailsParams): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new GetBaasClusterDetailsRequest({ ...params }));
  }

  export function rejectPoolNode(params: IRejectPoolNodeParams): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new RejectPoolNodeRequest({ ...params }));
  }

  export function deletePoolNode(params: IDeletePoolNodeParams): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new DeletePoolNodeRequest({ ...params }));
  }

  export function getDockerRegistry(params: IGetDockerRegistryParams): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new GetDockerRegistryRequest({ ...params }));
  }

  export function downloadScript(params: IDownloadScriptParams): Promise<IResult> {
    WindowLocationService.download(WebHttpClient.FILE_UPLOAD_API_PREFIX+'baas/'+params.siteId+'/'+params.clusterId+'/onboardNodeFile');
    return Promise.resolve({});
  }
}
